/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1EtsyInfoPackByMID, updateTKT1EtsyInfoPack, getTKT1BankBrands } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import {
  Badge,
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Modal,
  Toast,
  ToastContainer,
  Tabs,
  Tab
} from "react-bootstrap";
import { FaEdit, FaCopy, FaCog, FaChevronLeft, FaChevronRight, FaDownload, FaExternalLinkAlt } from 'react-icons/fa';
import Select from 'react-select';

class TKT1EtsyInfoPackDetail extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      showEditModal: false,
      showToast: false,
      toastMessage: '',
      toastType: 'success',
      trustedPersons: [],
      c3dInfos: [],
      trustedBankAccounts: [],
      trustedBankVisas: [],
      trustedStories: [],
      scanPersons: [],
      bankBrands: [],
      // Info modals
      showTrustedPersonInfoModal: false,
      showC3DInfoModal: false,
      showScanPersonInfoModal: false,
      showBankAccountInfoModal: false,
      showBankVisaInfoModal: false,
      showDevicePackInfoModal: false,
      showStoryInfoModal: false,
      showSetupEtsyInfoModal: false,
      selectedInfoData: null,
      // Photo modal state
      showPhotosModal: false,
      selectedPhotos: [],
      currentPhotoIndex: 0,
      editFormData: {
        trusted_person_mid: '',
        valid_c3d_number: '',
        scan_person_mid: '',
        trusted_bank_acc_mid: '',
        trusted_bank_visa_mid: '',
        device_pack_location_id: '',
        trusted_story_mid: '',
        seller_address: '',
        sim_mid: '',
        email1_mid: '',
        email2_mid: '',
        note: '',
        status: 'ACTIVE'
      }
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Etsy Info Pack Detail';
    const { packId } = this.props.match.params;
    
    if (packId) {
      console.log('Component mounted with packId:', packId);
      this.loadEtsyInfoPackDetail(packId);
    }
    
    this.loadDropdownData();
    
    // Add keyboard event listener for photo modal
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    // Remove keyboard event listener
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  loadEtsyInfoPackDetail = async (mid) => {
    try {
      this.setState({ loading: true });
      console.log('Loading etsy info pack detail for MID:', mid);
      const result = await this.props.getTKT1EtsyInfoPackByMID(mid);
      console.log('API call result:', result);
    } catch (error) {
      console.error('Error loading etsy info pack detail:', error);
      this.showToast('Lỗi khi tải thông tin Etsy Info Pack', 'error');
    } finally {
      this.setState({ loading: false });
    }
  }

  loadDropdownData = async () => {
    await Promise.all([
      this.loadTrustedPersons(),
      this.loadC3DInfos(),
      this.loadBankAccounts(),
      this.loadBankVisas(),
      this.loadStories(),
      this.loadScanPersons(),
      this.loadBankBrands()
    ]);
  }

  loadTrustedPersons = async () => {
    try {
      // Load trusted persons data
      // Implementation depends on your API structure
    } catch (error) {
      console.error('Error loading trusted persons:', error);
    }
  }

  loadC3DInfos = async () => {
    try {
      // Load C3D infos data
      // Implementation depends on your API structure
    } catch (error) {
      console.error('Error loading C3D infos:', error);
    }
  }

  loadBankAccounts = async () => {
    try {
      // Load bank accounts data
      // Implementation depends on your API structure
    } catch (error) {
      console.error('Error loading bank accounts:', error);
    }
  }

  loadBankVisas = async () => {
    try {
      // Load bank visas data
      // Implementation depends on your API structure
    } catch (error) {
      console.error('Error loading bank visas:', error);
    }
  }

  loadStories = async () => {
    try {
      // Load stories data
      // Implementation depends on your API structure
    } catch (error) {
      console.error('Error loading stories:', error);
    }
  }

  loadScanPersons = async () => {
    try {
      // Load scan persons data
      // Implementation depends on your API structure
    } catch (error) {
      console.error('Error loading scan persons:', error);
    }
  }

  loadBankBrands = async () => {
    try {
      console.log('Loading bank brands...');
      // Create a basic query to get all bank brands
      const query = {
        currentPage: 1,
        itemsPerPage: 1000, // Get all bank brands
        sortBy: 'bank_name',
        sortOrder: 1,
        search: '',
        is_active: 'true' // Only get active bank brands
      };
      console.log('Query for bank brands:', query);
      const result = await this.props.getTKT1BankBrands(query);
      console.log('Bank brands loaded:', result);
      console.log('Bank brands in state:', this.props.bankBrands);
    } catch (error) {
      console.error('Error loading bank brands:', error);
    }
  }

  showToast = (message, type = 'success') => {
    this.setState({
      showToast: true,
      toastMessage: message,
      toastType: type
    });

    setTimeout(() => {
      this.setState({ showToast: false });
    }, 3000);
  }

  handleEditClick = (pack) => {
    this.setState({
      showEditModal: true,
      selectedEtsyInfoPack: pack,
      isEditMode: true,
      editFormData: {
        trusted_person_mid: pack.trusted_person_mid || '',
        valid_c3d_number: pack.valid_c3d_number || '',
        scan_person_mid: pack.scan_person_mid || '',
        trusted_bank_acc_mid: pack.trusted_bank_acc_mid || '',
        trusted_bank_visa_mid: pack.trusted_bank_visa_mid || '',
        device_pack_location_id: pack.device_pack_location_id || '',
        trusted_story_mid: pack.trusted_story_mid || '',
        seller_address: pack.seller_address || '',
        sim_mid: pack.sim_mid || '',
        email1_mid: pack.email1_mid || '',
        email2_mid: pack.email2_mid || '',
        note: pack.note || '',
        status: pack.status || 'active'
      }
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedEtsyInfoPack: null,
      isEditMode: false,
      editFormData: {
        trusted_person_mid: '',
        valid_c3d_number: '',
        scan_person_mid: '',
        trusted_bank_acc_mid: '',
        trusted_bank_visa_mid: '',
        device_pack_location_id: '',
        trusted_story_mid: '',
        seller_address: '',
        sim_mid: '',
        email1_mid: '',
        email2_mid: '',
        note: '',
        status: 'ACTIVE'
      }
    });
  }

  handleFormChange = (field, value) => {
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        [field]: value
      }
    });
  }


  handleSubmitEdit = async () => {
    const { selectedEtsyInfoPack, editFormData } = this.state;
    
    if (!selectedEtsyInfoPack || !selectedEtsyInfoPack._id) {
      this.showToast('Không tìm thấy thông tin Etsy Info Pack để cập nhật', 'error');
      return;
    }

    try {
      await this.props.updateTKT1EtsyInfoPack(selectedEtsyInfoPack._id, editFormData);
      
      this.handleCloseEditModal();
      this.showToast('Cập nhật thông tin Etsy Info Pack thành công!', 'success');
      
      // Reload the detail page
      const { packId } = this.props.match.params;
      if (packId) {
        this.loadEtsyInfoPackDetail(packId);
      }
    } catch (error) {
      console.error('Error updating etsy info pack:', error);
      this.showToast('Lỗi khi cập nhật thông tin Etsy Info Pack. Vui lòng thử lại.', 'error');
    }
  }


  // Info modal handlers
  handleViewTrustedPersonInfo = (mid) => {
    // Implementation for viewing trusted person info
  }

  handleViewC3DInfo = (c3dNumber) => {
    // Implementation for viewing C3D info
  }

  handleViewScanPersonInfo = (mid) => {
    // Implementation for viewing scan person info
  }

  handleViewBankAccountInfo = (mid) => {
    // Implementation for viewing bank account info
  }

  handleViewBankVisaInfo = (mid) => {
    // Implementation for viewing bank visa info
  }

  handleViewDevicePackInfo = (locationId) => {
    // Implementation for viewing device pack info
  }

  handleViewStoryInfo = (mid) => {
    // Implementation for viewing story info
  }

  handleViewSetupEtsyInfo = () => {
    this.setState({
      showSetupEtsyInfoModal: true
    });
  }

  handleCloseSetupEtsyInfoModal = () => {
    this.setState({ 
      showSetupEtsyInfoModal: false
    });
  }

  // Photo modal handlers
  handlePhotosClick = (photos) => {
    this.setState({
      showPhotosModal: true,
      selectedPhotos: photos || [],
      currentPhotoIndex: 0
    });
  }

  handleClosePhotosModal = () => {
    this.setState({
      showPhotosModal: false,
      selectedPhotos: [],
      currentPhotoIndex: 0
    });
  }

  handlePrevPhoto = () => {
    this.setState(prevState => ({
      currentPhotoIndex: prevState.currentPhotoIndex > 0 
        ? prevState.currentPhotoIndex - 1 
        : prevState.selectedPhotos.length - 1
    }));
  }

  handleNextPhoto = () => {
    this.setState(prevState => ({
      currentPhotoIndex: prevState.currentPhotoIndex < prevState.selectedPhotos.length - 1 
        ? prevState.currentPhotoIndex + 1 
        : 0
    }));
  }

  handleDownloadImage = (imageUrl, fileName) => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  handleKeyDown = (e) => {
    // Only handle keyboard events when photos modal is open
    if (!this.state.showPhotosModal) {
      return;
    }

    switch (e.key) {
      case 'ArrowLeft':
        if (this.state.selectedPhotos.length > 1) {
          e.preventDefault();
          this.handlePrevPhoto();
        }
        break;
      case 'ArrowRight':
        if (this.state.selectedPhotos.length > 1) {
          e.preventDefault();
          this.handleNextPhoto();
        }
        break;
      case 'Escape':
        e.preventDefault();
        this.handleClosePhotosModal();
        break;
      default:
        break;
    }
  }

  copyToClipboard = (text) => {
    if (text) {
      navigator.clipboard.writeText(text).then(() => {
        this.showToast('Đã copy vào clipboard!', 'success');
      }).catch(() => {
        this.showToast('Không thể copy vào clipboard', 'error');
      });
    }
  }

  getSwiftCodeFromBankBrand = (bankShortName) => {
    if (!bankShortName || !this.props.bankBrands) {
      console.log('getSwiftCodeFromBankBrand: Missing bankShortName or bankBrands', { bankShortName, bankBrands: this.props.bankBrands });
      return '';
    }
    
    const bankBrand = this.props.bankBrands.find(brand => 
      brand.short_name === bankShortName || 
      brand.bank_name === bankShortName ||
      brand.bank_code === bankShortName
    );
    
    console.log('getSwiftCodeFromBankBrand: Found bank brand', { bankShortName, bankBrand, swiftCode: bankBrand?.swift_code });
    
    return bankBrand?.swift_code || '';
  }

  render() {
    const { etsyInfoPack } = this.props;
    const { loading, showEditModal, editFormData, showToast, toastMessage, toastType } = this.state;
    
    console.log('TKT1EtsyInfoPackDetail render - etsyInfoPack:', etsyInfoPack);
    console.log('TKT1EtsyInfoPackDetail render - loading:', loading);

    if (loading) {
      return (
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <div className="text-center">
                <h4>Đang tải...</h4>
              </div>
            </Col>
          </Row>
        </Container>
      );
    }

    if (!etsyInfoPack) {
      return (
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <div className="text-center">
                <h4>Không tìm thấy thông tin Etsy Info Pack</h4>
              </div>
            </Col>
          </Row>
        </Container>
      );
    }

    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary mb-0">
                TKT1 Etsy Info Pack Detail - {etsyInfoPack.MID}
              </h2>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <Card.Header>
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Thông tin chi tiết</h5>
                    <div className="d-flex gap-2">
                      <Button 
                        variant="success" 
                        onClick={this.handleViewSetupEtsyInfo}
                      >
                        <FaCog className="me-2" />
                        Setup Etsy
                      </Button>
                      <Button 
                        variant="primary" 
                        onClick={() => this.handleEditClick(etsyInfoPack)}
                      >
                        <FaEdit className="me-2" />
                        Chỉnh sửa
                      </Button>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body style={{ padding: '0' }}>
                  <Tabs defaultActiveKey="basic" id="etsy-info-tabs" className="mb-3">
                    {/* Tab 0: Basic Information */}
                    <Tab eventKey="basic" title="📋 Basic Info">
                      <div style={{ padding: '1rem' }}>
                        <Row className="mb-4">
                          <Col>
                            <h5 className="text-primary">Thông tin cơ bản Etsy Info Pack</h5>
                            <hr />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <strong>MID:</strong> 
                            <div className="mt-1">
                              <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                {etsyInfoPack.MID}
                              </Badge>
                            </div>
                          </Col>
                          <Col md="6">
                            <strong>Trạng thái:</strong> 
                            <div className="mt-1">
                              <Badge 
                                bg={etsyInfoPack.status === 'active' ? 'success' : 'danger'} 
                                style={{ fontSize: '0.8em', padding: '4px 8px' }}
                              >
                                {etsyInfoPack.status === 'active' ? 'Hoạt động' : 'Không hoạt động'}
                              </Badge>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <strong>Đang hoạt động:</strong> 
                            <div className="mt-1">
                              <Badge 
                                bg={etsyInfoPack.is_active ? 'success' : 'danger'} 
                                style={{ fontSize: '0.8em', padding: '4px 8px' }}
                              >
                                {etsyInfoPack.is_active ? 'Có' : 'Không'}
                              </Badge>
                            </div>
                          </Col>
                          <Col md="6">
                            <strong>Đã xóa:</strong> 
                            <div className="mt-1">
                              <Badge 
                                bg={etsyInfoPack.is_deleted ? 'danger' : 'success'} 
                                style={{ fontSize: '0.8em', padding: '4px 8px' }}
                              >
                                {etsyInfoPack.is_deleted ? 'Có' : 'Không'}
                              </Badge>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <strong>Ngày tạo:</strong> 
                            <div className="mt-1">
                              {etsyInfoPack.created_at ? 
                                new Date(etsyInfoPack.created_at).toLocaleString('vi-VN') : '-'}
                            </div>
                          </Col>
                          <Col md="6">
                            <strong>Ngày cập nhật:</strong> 
                            <div className="mt-1">
                              {etsyInfoPack.updated_at ? 
                                new Date(etsyInfoPack.updated_at).toLocaleString('vi-VN') : '-'}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <strong>Trusted Person MID:</strong> 
                            <div className="mt-1">
                              <Badge bg="info" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                {etsyInfoPack.trusted_person_mid ? 
                                  `[${etsyInfoPack.trusted_person_mid}] ${etsyInfoPack.trusted_person_info?.full_name || ''}` : 
                                  '-'
                                }
                              </Badge>
                            </div>
                          </Col>
                          <Col md="6">
                            <strong>Valid C3D Number:</strong> 
                            <div className="mt-1">
                              <Badge bg="success" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                {etsyInfoPack.valid_c3d_number || '-'}
                              </Badge>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <strong>Scan Person MID:</strong> 
                            <div className="mt-1">
                              <Badge bg="warning" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                {etsyInfoPack.scan_person_mid ? 
                                  `[${etsyInfoPack.scan_person_mid}] ${etsyInfoPack.scan_person_info?.name || ''}` : 
                                  '-'
                                }
                              </Badge>
                            </div>
                          </Col>
                          <Col md="6">
                            <strong>Device Pack Location ID:</strong> 
                            <div className="mt-1">
                              <Badge bg="secondary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                {etsyInfoPack.device_pack_location_id || '-'}
                              </Badge>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <strong>Trusted Bank Account MID:</strong> 
                            <div className="mt-1">
                              <Badge bg="primary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                {etsyInfoPack.trusted_bank_acc_mid || '-'}
                              </Badge>
                            </div>
                          </Col>
                          <Col md="6">
                            <strong>Trusted Bank Visa MID:</strong> 
                            <div className="mt-1">
                              <Badge bg="success" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                {etsyInfoPack.trusted_bank_visa_mid || '-'}
                              </Badge>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <strong>Trusted Story MID:</strong> 
                            <div className="mt-1">
                              <Badge bg="warning" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                {etsyInfoPack.trusted_story_mid || '-'}
                              </Badge>
                            </div>
                          </Col>
                          <Col md="6">
                            <strong>Metadata:</strong> 
                            <div className="mt-1">
                              {etsyInfoPack.metadata && Object.keys(etsyInfoPack.metadata).length > 0 ? 
                                JSON.stringify(etsyInfoPack.metadata) : '-'}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <strong>Địa chỉ người bán:</strong> 
                            <div className="mt-1">
                              {etsyInfoPack.seller_address || '-'}
                            </div>
                          </Col>
                          <Col md="6">
                            <strong>Số SIM / Số điện thoại:</strong> 
                            <div className="mt-1">
                              {etsyInfoPack.sim_mid ? (
                                <Badge bg="info" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                  {etsyInfoPack.sim_mid}
                                </Badge>
                              ) : '-'}
                            </div>
                          </Col>
                        </Row>
                        {etsyInfoPack.note && (
                          <Row className="mb-3">
                            <Col md="12">
                              <strong>Ghi chú:</strong> 
                              <div className="mt-1">
                                {etsyInfoPack.note}
                              </div>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </Tab>

                    {/* Tab 1: Trust Person + Valid C3D + Scan Person */}
                    <Tab eventKey="person" title="👤 Person Info">
                      <div style={{ padding: '1rem' }}>
                        <Row className="mb-4">
                          <Col>
                            <h5 className="text-primary">Thông tin Trust Person</h5>
                            <hr />
                          </Col>
                        </Row>
                        {etsyInfoPack.trusted_person_info ? (
                          <div>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>MID:</strong> 
                                <div className="mt-1">
                                  <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                    {etsyInfoPack.trusted_person_info.MID}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Tên đầy đủ:</strong> 
                                <div className="mt-1 fw-bold">{etsyInfoPack.trusted_person_info.full_name}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Tên tiếng Anh:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_person_info.full_name_english || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Đầu mối:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_person_info.relation_with || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Ghi chú quan hệ:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_person_info.relation_note || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Thành phố hiện tại:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_person_info.current_city || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Địa chỉ:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_person_info.address || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Nơi sinh:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_person_info.c3d_place_of_origin || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Thành phố C3D:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_person_info.c3d_city || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Đã đăng ký Etsy:</strong> 
                                <div className="mt-1">
                                  <Badge 
                                    bg={etsyInfoPack.trusted_person_info.is_registered_etsy ? 'success' : 'warning'} 
                                    style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                  >
                                    {etsyInfoPack.trusted_person_info.is_registered_etsy ? 'Có' : 'Chưa'}
                                  </Badge>
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Matching C3D Total:</strong> 
                                <div className="mt-1">
                                  <Badge bg="info" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                    {etsyInfoPack.trusted_person_info.matching_c3d_total || 0}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Matching C3D Tax Total:</strong> 
                                <div className="mt-1">
                                  <Badge bg="success" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                    {etsyInfoPack.trusted_person_info.matching_c3d_tax_total || 0}
                                  </Badge>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        ) : (
                          <div className="text-center text-muted">
                            <p>Không có thông tin Trust Person</p>
                          </div>
                        )}

                        <Row className="mb-4 mt-4">
                          <Col>
                            <h5 className="text-success">Thông tin C3D</h5>
                            <hr />
                          </Col>
                        </Row>
                        {etsyInfoPack.valid_c3d_person_info ? (
                          <div>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Số C3D:</strong> 
                                <div className="mt-1">
                                  <Badge bg="success" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                    {etsyInfoPack.valid_c3d_person_info.c3d_number}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Họ tên:</strong> 
                                <div className="mt-1 fw-bold">{etsyInfoPack.valid_c3d_person_info.full_name}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Họ tên tiếng Anh:</strong> 
                                <div className="mt-1">{etsyInfoPack.valid_c3d_person_info.full_name_english || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Ngày sinh:</strong> 
                                <div className="mt-1">{etsyInfoPack.valid_c3d_person_info.c3d_dob || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Giới tính:</strong> 
                                <div className="mt-1">
                                  <Badge 
                                    bg={etsyInfoPack.valid_c3d_person_info.c3d_sex === 'MALE' ? 'primary' : 'danger'} 
                                    style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                  >
                                    {etsyInfoPack.valid_c3d_person_info.c3d_sex === 'MALE' ? 'Nam' : 'Nữ'}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Nơi sinh:</strong> 
                                <div className="mt-1">{etsyInfoPack.valid_c3d_person_info.c3d_place_of_origin || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Nơi cư trú:</strong> 
                                <div className="mt-1">{etsyInfoPack.valid_c3d_person_info.c3d_place_of_residence || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Thành phố:</strong> 
                                <div className="mt-1">{etsyInfoPack.valid_c3d_person_info.c3d_city || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Nguồn:</strong> 
                                <div className="mt-1">
                                  <Badge bg="info" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                    {etsyInfoPack.valid_c3d_person_info.source || '-'}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Trạng thái Etsy:</strong> 
                                <div className="mt-1">
                                  <Badge 
                                    bg={etsyInfoPack.valid_c3d_person_info.info_etsy_status === 'FOUND_TRUSTED_INFO' ? 'success' : 'warning'} 
                                    style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                  >
                                    {etsyInfoPack.valid_c3d_person_info.info_etsy_status === 'FOUND_TRUSTED_INFO' ? 'Đã tìm thấy' : 'Chưa tìm thấy'}
                                  </Badge>
                                </div>
                              </Col>
                            </Row>
                            {etsyInfoPack.valid_c3d_person_info.TNCN_tax_infos && etsyInfoPack.valid_c3d_person_info.TNCN_tax_infos.length > 0 && (
                              <Row className="mb-3">
                                <Col md="12">
                                  <strong>Thông tin thuế TNCN:</strong>
                                  <div className="mt-1">
                                    {etsyInfoPack.valid_c3d_person_info.TNCN_tax_infos.map((tax, index) => (
                                      <div key={index} className="border p-2 mb-2 rounded">
                                        <Row>
                                          <Col md="6">
                                            <strong>Người nộp thuế:</strong> {tax.payer_name}
                                          </Col>
                                          <Col md="6">
                                            <strong>Cơ quan thuế:</strong> {tax.tax_authority}
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col md="6">
                                            <strong>Thành phố:</strong> {tax.city}
                                          </Col>
                                          <Col md="6">
                                            <strong>Trạng thái:</strong> 
                                            <Badge 
                                              bg={tax.status === 'ACTIVE' ? 'success' : 'danger'} 
                                              style={{ fontSize: '0.7em', padding: '2px 6px' }}
                                            >
                                              {tax.status_text}
                                            </Badge>
                                          </Col>
                                        </Row>
                                      </div>
                                    ))}
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </div>
                        ) : (
                          <div className="text-center text-muted">
                            <p>Không có thông tin C3D</p>
                          </div>
                        )}

                        <Row className="mb-4 mt-4">
                          <Col>
                            <h5 className="text-warning">Thông tin Scan Person</h5>
                            <hr />
                          </Col>
                        </Row>
                        {etsyInfoPack.scan_person_info ? (
                          <div>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>MID:</strong> 
                                <div className="mt-1">
                                  <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                    {etsyInfoPack.scan_person_info.MID}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Tên:</strong> 
                                <div className="mt-1 fw-bold">{etsyInfoPack.scan_person_info.name}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Địa chỉ:</strong> 
                                <div className="mt-1">{etsyInfoPack.scan_person_info.address || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Thành phố:</strong> 
                                <div className="mt-1">{etsyInfoPack.scan_person_info.current_city || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Số điện thoại:</strong> 
                                <div className="mt-1">{etsyInfoPack.scan_person_info.phone || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Facebook:</strong> 
                                <div className="mt-1">{etsyInfoPack.scan_person_info.facebook_link || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Trạng thái:</strong> 
                                <div className="mt-1">
                                  <Badge 
                                    bg={etsyInfoPack.scan_person_info.status === 'active' ? 'success' : 'danger'} 
                                    style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                  >
                                    {etsyInfoPack.scan_person_info.status === 'active' ? 'Hoạt động' : 'Không hoạt động'}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Ghi chú liên hệ:</strong> 
                                <div className="mt-1">{etsyInfoPack.scan_person_info.contact_note || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Nơi sinh C3D:</strong> 
                                <div className="mt-1">{etsyInfoPack.scan_person_info.c3d_place_of_origin || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Nơi cư trú C3D:</strong> 
                                <div className="mt-1">{etsyInfoPack.scan_person_info.c3d_place_of_residence || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Thành phố C3D:</strong> 
                                <div className="mt-1">{etsyInfoPack.scan_person_info.c3d_city || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Giới tính C3D:</strong> 
                                <div className="mt-1">{etsyInfoPack.scan_person_info.c3d_sex || '-'}</div>
                              </Col>
                            </Row>

                            {/* Photos Section */}
                            {etsyInfoPack.scan_person_info.photos && etsyInfoPack.scan_person_info.photos.length > 0 && (
                              <div>
                                <Row className="mb-3">
                                  <Col>
                                    <strong>Số ảnh:</strong> 
                                    <div className="mt-1 d-flex align-items-center gap-2">
                                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                        {etsyInfoPack.scan_person_info.photos.length} ảnh
                                      </Badge>
                                      <Button 
                                        variant="outline-primary" 
                                        size="sm"
                                        onClick={() => this.handlePhotosClick(etsyInfoPack.scan_person_info.photos)}
                                      >
                                        <i className="fas fa-images me-1"></i>
                                        Xem ảnh
                                      </Button>
                                    </div>
                                  </Col>
                                </Row>

                                {/* Photos Thumbnails */}
                                <Row className="mb-3">
                                  <Col>
                                    <strong>Ảnh:</strong>
                                    <div className="mt-2 d-flex flex-wrap gap-2">
                                      {etsyInfoPack.scan_person_info.photos.slice(0, 6).map((photo, index) => (
                                        <div 
                                          key={index}
                                          style={{ 
                                            cursor: 'pointer',
                                            border: '2px solid #dee2e6',
                                            borderRadius: '8px',
                                            overflow: 'hidden',
                                            transition: 'all 0.2s ease'
                                          }}
                                          onClick={() => this.handlePhotosClick(etsyInfoPack.scan_person_info.photos)}
                                          onMouseEnter={(e) => {
                                            e.target.style.borderColor = '#007bff';
                                            e.target.style.transform = 'scale(1.05)';
                                          }}
                                          onMouseLeave={(e) => {
                                            e.target.style.borderColor = '#dee2e6';
                                            e.target.style.transform = 'scale(1)';
                                          }}
                                        >
                                          <img 
                                            src={photo.link} 
                                            alt={photo.description || `Ảnh ${index + 1}`}
                                            style={{ 
                                              width: '80px', 
                                              height: '80px', 
                                              objectFit: 'cover'
                                            }}
                                          />
                                        </div>
                                      ))}
                                      {etsyInfoPack.scan_person_info.photos.length > 6 && (
                                        <div 
                                          style={{ 
                                            width: '80px', 
                                            height: '80px', 
                                            backgroundColor: '#f8f9fa',
                                            border: '2px solid #dee2e6',
                                            borderRadius: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease'
                                          }}
                                          onClick={() => this.handlePhotosClick(etsyInfoPack.scan_person_info.photos)}
                                          onMouseEnter={(e) => {
                                            e.target.style.borderColor = '#007bff';
                                            e.target.style.backgroundColor = '#e7f3ff';
                                          }}
                                          onMouseLeave={(e) => {
                                            e.target.style.borderColor = '#dee2e6';
                                            e.target.style.backgroundColor = '#f8f9fa';
                                          }}
                                        >
                                          <div className="text-center">
                                            <i className="fas fa-plus fa-lg text-muted"></i>
                                            <div className="small text-muted">+{etsyInfoPack.scan_person_info.photos.length - 6}</div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="text-center text-muted">
                            <p>Không có thông tin Scan Person</p>
                          </div>
                        )}
                      </div>
                    </Tab>

                    {/* Tab 2: Bank Information */}
                    <Tab eventKey="bank" title="🏦 Bank Info">
                      <div style={{ padding: '1rem' }}>
                        <Row className="mb-4">
                          <Col>
                            <h5 className="text-primary">Thông tin Bank Account</h5>
                            <hr />
                          </Col>
                        </Row>
                        {etsyInfoPack.trusted_bank_account_info ? (
                          <div>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>MID:</strong> 
                                <div className="mt-1">
                                  <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                    {etsyInfoPack.trusted_bank_account_info.MID}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Ngân hàng:</strong> 
                                <div className="mt-1 fw-bold">{etsyInfoPack.trusted_bank_account_info.bank_short_name}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Tên chủ tài khoản:</strong> 
                                <div className="mt-1 fw-bold">{etsyInfoPack.trusted_person_info?.full_name || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Tên tiếng Anh:</strong> 
                                <div className="mt-1 d-flex align-items-center gap-2">
                                  <span className="fw-bold" style={{ flex: 1 }}>
                                    {etsyInfoPack.trusted_person_info?.full_name_english || '-'}
                                  </span>
                                  {etsyInfoPack.trusted_person_info?.full_name_english && (
                                    <FaCopy 
                                      size={12} 
                                      style={{ cursor: 'pointer', color: '#6c757d' }}
                                      onClick={() => this.copyToClipboard(etsyInfoPack.trusted_person_info.full_name_english)}
                                      title="Copy English Name"
                                    />
                                  )}
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Số tài khoản:</strong> 
                                <div className="mt-1 d-flex align-items-center gap-2">
                                  <span style={{ flex: 1 }}>
                                    {etsyInfoPack.trusted_bank_account_info.account_number || '-'}
                                  </span>
                                  {etsyInfoPack.trusted_bank_account_info.account_number && (
                                    <FaCopy 
                                      size={12} 
                                      style={{ cursor: 'pointer', color: '#6c757d' }}
                                      onClick={() => this.copyToClipboard(etsyInfoPack.trusted_bank_account_info.account_number)}
                                      title="Copy Account Number"
                                    />
                                  )}
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Chi nhánh:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_account_info.branch_name || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Loại tài khoản:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_account_info.type || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Ngày mở:</strong> 
                                <div className="mt-1">
                                  {etsyInfoPack.trusted_bank_account_info.open_date ? 
                                    new Date(etsyInfoPack.trusted_bank_account_info.open_date).toLocaleDateString('vi-VN') : '-'}
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Trạng thái:</strong> 
                                <div className="mt-1">
                                  <Badge 
                                    bg={etsyInfoPack.trusted_bank_account_info.status === 'active' ? 'success' : 'danger'} 
                                    style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                  >
                                    {etsyInfoPack.trusted_bank_account_info.status === 'active' ? 'Hoạt động' : 'Không hoạt động'}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Ghi chú:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_account_info.account_note || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Phí mở tài khoản:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_account_info.opening_fee || 0} VNĐ</div>
                              </Col>
                              <Col md="6">
                                <strong>Phí hàng năm:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_account_info.annual_fee || 0} VNĐ</div>
                              </Col>
                            </Row>
                          </div>
                        ) : (
                          <div className="text-center text-muted">
                            <p>Không có thông tin Bank Account</p>
                          </div>
                        )}

                        <Row className="mb-4 mt-4">
                          <Col>
                            <h5 className="text-success">Thông tin Bank Visa</h5>
                            <hr />
                          </Col>
                        </Row>
                        {etsyInfoPack.trusted_bank_visa_info ? (
                          <div>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>MID:</strong> 
                                <div className="mt-1">
                                  <Badge bg="success" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                    {etsyInfoPack.trusted_bank_visa_info.MID}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Ngân hàng:</strong> 
                                <div className="mt-1 fw-bold">{etsyInfoPack.trusted_bank_visa_info.bank_name}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Số thẻ:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_visa_info.visa_number || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Chi nhánh:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_visa_info.branch_name || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Tên chủ thẻ:</strong> 
                                <div className="mt-1 fw-bold">{etsyInfoPack.trusted_person_info?.full_name || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Tên tiếng Anh:</strong> 
                                <div className="mt-1 d-flex align-items-center gap-2">
                                  <span className="fw-bold" style={{ flex: 1 }}>
                                    {etsyInfoPack.trusted_person_info?.full_name_english || '-'}
                                  </span>
                                  {etsyInfoPack.trusted_person_info?.full_name_english && (
                                    <FaCopy 
                                      size={12} 
                                      style={{ cursor: 'pointer', color: '#6c757d' }}
                                      onClick={() => this.copyToClipboard(etsyInfoPack.trusted_person_info.full_name_english)}
                                      title="Copy English Name"
                                    />
                                  )}
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Loại thẻ:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_visa_info.type || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Tháng hết hạn:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_visa_info.valid_month || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Năm hết hạn:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_visa_info.valid_year || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>CVV:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_visa_info.cvvx || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Tài khoản liên kết:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_visa_info.deposit_bank_account_mid || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Trạng thái:</strong> 
                                <div className="mt-1">
                                  <Badge 
                                    bg={etsyInfoPack.trusted_bank_visa_info.status === 'active' ? 'success' : 'danger'} 
                                    style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                  >
                                    {etsyInfoPack.trusted_bank_visa_info.status === 'active' ? 'Hoạt động' : 'Không hoạt động'}
                                  </Badge>
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Phí mở thẻ:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_visa_info.opening_fee || 0} VNĐ</div>
                              </Col>
                              <Col md="6">
                                <strong>Phí hàng năm:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_visa_info.annual_fee || 0} VNĐ</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="12">
                                <strong>Ghi chú:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_bank_visa_info.account_note || '-'}</div>
                              </Col>
                            </Row>
                          </div>
                        ) : (
                          <div className="text-center text-muted">
                            <p>Không có thông tin Bank Visa</p>
                          </div>
                        )}
                      </div>
                    </Tab>

                    {/* Tab 3: Email Information */}
                    <Tab eventKey="email" title="📧 Email Info">
                      <div style={{ padding: '1rem' }}>
                        <Row className="mb-4">
                          <Col>
                            <h5 className="text-info">Thông tin Email 1</h5>
                            <hr />
                          </Col>
                        </Row>
                        {etsyInfoPack.email1_info ? (
                          <div>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>MID:</strong> 
                                <div className="mt-1">
                                  <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                    {etsyInfoPack.email1_info.MID}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Email:</strong> 
                                <div className="mt-1">
                                  <div className="d-flex align-items-center gap-2">
                                    <Badge bg="primary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                      {etsyInfoPack.email1_info.email || 'Chưa có email'}
                                    </Badge>
                                    {etsyInfoPack.email1_info.email && (
                                      <FaCopy 
                                        size={12} 
                                        style={{ cursor: 'pointer', color: '#6c757d' }}
                                        onClick={() => this.copyToClipboard(etsyInfoPack.email1_info.email)}
                                        title="Copy Email 1"
                                      />
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Tên:</strong> 
                                <div className="mt-1 fw-bold">{etsyInfoPack.email1_info.name || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Quốc gia:</strong> 
                                <div className="mt-1">{etsyInfoPack.email1_info.country || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Mật khẩu:</strong> 
                                <div className="mt-1 d-flex align-items-center gap-2">
                                  <Badge bg="warning" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                    {etsyInfoPack.email1_info.password || '-'}
                                  </Badge>
                                  {etsyInfoPack.email1_info.password && (
                                    <FaCopy 
                                      size={12} 
                                      style={{ cursor: 'pointer', color: '#6c757d' }}
                                      onClick={() => this.copyToClipboard(etsyInfoPack.email1_info.password)}
                                      title="Copy Password"
                                    />
                                  )}
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Recovery Email:</strong> 
                                <div className="mt-1 d-flex align-items-center gap-2">
                                  <span>{etsyInfoPack.email1_info.recovery_email || '-'}</span>
                                  {etsyInfoPack.email1_info.recovery_email && (
                                    <FaCopy 
                                      size={12} 
                                      style={{ cursor: 'pointer', color: '#6c757d' }}
                                      onClick={() => this.copyToClipboard(etsyInfoPack.email1_info.recovery_email)}
                                      title="Copy Recovery Email"
                                    />
                                  )}
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>2FA Code:</strong> 
                                <div className="mt-1 d-flex align-items-center gap-2">
                                  <span>{etsyInfoPack.email1_info.code_2fa || '-'}</span>
                                  {etsyInfoPack.email1_info.code_2fa && (
                                    <FaCopy 
                                      size={12} 
                                      style={{ cursor: 'pointer', color: '#6c757d' }}
                                      onClick={() => this.copyToClipboard(etsyInfoPack.email1_info.code_2fa)}
                                      title="Copy 2FA Code"
                                    />
                                  )}
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Số điện thoại:</strong> 
                                <div className="mt-1">{etsyInfoPack.email1_info.phone || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Trạng thái:</strong> 
                                <div className="mt-1">
                                  <Badge 
                                    bg={etsyInfoPack.email1_info.status === 'ACTIVE' ? 'success' : 'danger'} 
                                    style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                  >
                                    {etsyInfoPack.email1_info.status === 'ACTIVE' ? 'Hoạt động' : 'Không hoạt động'}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Giá:</strong> 
                                <div className="mt-1">
                                  {etsyInfoPack.email1_info.price ? (
                                    <span className="text-success fw-bold">
                                      {etsyInfoPack.email1_info.price.toLocaleString('vi-VN')} VNĐ
                                    </span>
                                  ) : '-'}
                                </div>
                              </Col>
                            </Row>
                            {etsyInfoPack.email1_info.avatar && (
                              <Row className="mb-3">
                                <Col md="12">
                                  <strong>Avatar:</strong> 
                                  <div className="mt-2">
                                    <img 
                                      src={etsyInfoPack.email1_info.avatar} 
                                      alt="Avatar"
                                      style={{ 
                                        width: '80px', 
                                        height: '80px', 
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        border: '2px solid #dee2e6'
                                      }}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </div>
                        ) : (
                          <div className="text-center text-muted">
                            <p>Không có thông tin Email 1</p>
                          </div>
                        )}

                        <Row className="mb-4 mt-4">
                          <Col>
                            <h5 className="text-secondary">Thông tin Email 2</h5>
                            <hr />
                          </Col>
                        </Row>
                        {etsyInfoPack.email2_info ? (
                          <div>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>MID:</strong> 
                                <div className="mt-1">
                                  <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                    {etsyInfoPack.email2_info.MID}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Email:</strong> 
                                <div className="mt-1">
                                  <div className="d-flex align-items-center gap-2">
                                    <Badge bg="secondary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                      {etsyInfoPack.email2_info.email || 'Chưa có email'}
                                    </Badge>
                                    {etsyInfoPack.email2_info.email && (
                                      <FaCopy 
                                        size={12} 
                                        style={{ cursor: 'pointer', color: '#6c757d' }}
                                        onClick={() => this.copyToClipboard(etsyInfoPack.email2_info.email)}
                                        title="Copy Email 2"
                                      />
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Tên:</strong> 
                                <div className="mt-1 fw-bold">{etsyInfoPack.email2_info.name || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Quốc gia:</strong> 
                                <div className="mt-1">{etsyInfoPack.email2_info.country || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Mật khẩu:</strong> 
                                <div className="mt-1 d-flex align-items-center gap-2">
                                  <Badge bg="warning" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                    {etsyInfoPack.email2_info.password || '-'}
                                  </Badge>
                                  {etsyInfoPack.email2_info.password && (
                                    <FaCopy 
                                      size={12} 
                                      style={{ cursor: 'pointer', color: '#6c757d' }}
                                      onClick={() => this.copyToClipboard(etsyInfoPack.email2_info.password)}
                                      title="Copy Password"
                                    />
                                  )}
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Recovery Email:</strong> 
                                <div className="mt-1 d-flex align-items-center gap-2">
                                  <span>{etsyInfoPack.email2_info.recovery_email || '-'}</span>
                                  {etsyInfoPack.email2_info.recovery_email && (
                                    <FaCopy 
                                      size={12} 
                                      style={{ cursor: 'pointer', color: '#6c757d' }}
                                      onClick={() => this.copyToClipboard(etsyInfoPack.email2_info.recovery_email)}
                                      title="Copy Recovery Email"
                                    />
                                  )}
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>2FA Code:</strong> 
                                <div className="mt-1 d-flex align-items-center gap-2">
                                  <span>{etsyInfoPack.email2_info.code_2fa || '-'}</span>
                                  {etsyInfoPack.email2_info.code_2fa && (
                                    <FaCopy 
                                      size={12} 
                                      style={{ cursor: 'pointer', color: '#6c757d' }}
                                      onClick={() => this.copyToClipboard(etsyInfoPack.email2_info.code_2fa)}
                                      title="Copy 2FA Code"
                                    />
                                  )}
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Số điện thoại:</strong> 
                                <div className="mt-1">{etsyInfoPack.email2_info.phone || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Trạng thái:</strong> 
                                <div className="mt-1">
                                  <Badge 
                                    bg={etsyInfoPack.email2_info.status === 'ACTIVE' ? 'success' : 'danger'} 
                                    style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                  >
                                    {etsyInfoPack.email2_info.status === 'ACTIVE' ? 'Hoạt động' : 'Không hoạt động'}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Giá:</strong> 
                                <div className="mt-1">
                                  {etsyInfoPack.email2_info.price ? (
                                    <span className="text-success fw-bold">
                                      {etsyInfoPack.email2_info.price.toLocaleString('vi-VN')} VNĐ
                                    </span>
                                  ) : '-'}
                                </div>
                              </Col>
                            </Row>
                            {etsyInfoPack.email2_info.avatar && (
                              <Row className="mb-3">
                                <Col md="12">
                                  <strong>Avatar:</strong> 
                                  <div className="mt-2">
                                    <img 
                                      src={etsyInfoPack.email2_info.avatar} 
                                      alt="Avatar"
                                      style={{ 
                                        width: '80px', 
                                        height: '80px', 
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        border: '2px solid #dee2e6'
                                      }}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </div>
                        ) : (
                          <div className="text-center text-muted">
                            <p>Không có thông tin Email 2</p>
                          </div>
                        )}
                      </div>
                    </Tab>

                    {/* Tab 4: Device Pack Information */}
                    <Tab eventKey="device" title="💻 Device Pack Info">
                      <div style={{ padding: '1rem' }}>
                        <Row className="mb-4">
                          <Col>
                            <h5 className="text-info">Thông tin Device Pack</h5>
                            <hr />
                          </Col>
                        </Row>
                        {etsyInfoPack.device_pack_info ? (
                          <div>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Location ID:</strong> 
                                <div className="mt-1">
                                  <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                    {etsyInfoPack.device_pack_info.location_id}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Trạng thái:</strong> 
                                <div className="mt-1">
                                  <Badge 
                                    bg={etsyInfoPack.device_pack_info.status === 'AVAILABLE' ? 'success' : 'warning'} 
                                    style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                  >
                                    {etsyInfoPack.device_pack_info.status === 'AVAILABLE' ? 'Có sẵn' : 'Không có sẵn'}
                                  </Badge>
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Network SN:</strong> 
                                <div className="mt-1">{etsyInfoPack.device_pack_info.NetworkSN || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>PC SN:</strong> 
                                <div className="mt-1">{etsyInfoPack.device_pack_info.PCSN || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Serial Number:</strong> 
                                <div className="mt-1">{etsyInfoPack.device_pack_info.SN || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Ultraview ID:</strong> 
                                <div className="mt-1">{etsyInfoPack.device_pack_info.ultraview_id || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Ultraview Password:</strong> 
                                <div className="mt-1">{etsyInfoPack.device_pack_info.ultraview_password || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>AnyDesk ID:</strong> 
                                <div className="mt-1">
                                  {etsyInfoPack.device_pack_info?.anydesk_id ? (
                                    <div className="d-flex align-items-center gap-2">
                                      <Badge bg="secondary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                        {etsyInfoPack.device_pack_info.anydesk_id}
                                      </Badge>
                                      <FaCopy 
                                        size={12} 
                                        style={{ cursor: 'pointer', color: '#6c757d' }}
                                        onClick={() => this.copyToClipboard(etsyInfoPack.device_pack_info.anydesk_id)}
                                        title="Copy AnyDesk ID"
                                      />
                                    </div>
                                  ) : '-'}
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>AnyDesk Password:</strong> 
                                <div className="mt-1">
                                  {etsyInfoPack.device_pack_info?.anydesk_password ? (
                                    <div className="d-flex align-items-center gap-2">
                                      <Badge bg="secondary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                        {etsyInfoPack.device_pack_info.anydesk_password}
                                      </Badge>
                                      <FaCopy 
                                        size={12} 
                                        style={{ cursor: 'pointer', color: '#6c757d' }}
                                        onClick={() => this.copyToClipboard(etsyInfoPack.device_pack_info.anydesk_password)}
                                        title="Copy AnyDesk Password"
                                      />
                                    </div>
                                  ) : '-'}
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Mô tả:</strong> 
                                <div className="mt-1">{etsyInfoPack.device_pack_info.description || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="12">
                                <strong>Ghi chú:</strong> 
                                <div className="mt-1">{etsyInfoPack.device_pack_info.note || '-'}</div>
                              </Col>
                            </Row>
                          </div>
                        ) : (
                          <div className="text-center text-muted">
                            <p>Không có thông tin Device Pack</p>
                          </div>
                        )}
                      </div>
                    </Tab>

                    {/* Tab 5: Story Information */}
                    <Tab eventKey="story" title="📖 Story Info">
                      <div style={{ padding: '1rem' }}>
                        <Row className="mb-4">
                          <Col>
                            <h5 className="text-warning">Thông tin Story</h5>
                            <hr />
                          </Col>
                        </Row>
                        {etsyInfoPack.trusted_story_info ? (
                          <div>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>MID:</strong> 
                                <div className="mt-1">
                                  <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                    {etsyInfoPack.trusted_story_info.MID}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Trạng thái:</strong> 
                                <div className="mt-1">
                                  <Badge 
                                    bg={etsyInfoPack.trusted_story_info.status === 'active' ? 'success' : 'danger'} 
                                    style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                  >
                                    {etsyInfoPack.trusted_story_info.status === 'active' ? 'Hoạt động' : 'Không hoạt động'}
                                  </Badge>
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Tên nghệ sĩ:</strong> 
                                <div className="mt-1 fw-bold">{etsyInfoPack.trusted_story_info.artist_name}</div>
                              </Col>
                              <Col md="6">
                                <strong>Tên shop Etsy:</strong> 
                                <div className="mt-1 fw-bold">{etsyInfoPack.trusted_story_info.etsy_shop_name}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="12">
                                <strong>Câu chuyện nghệ sĩ:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_story_info.artist_story || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="12">
                                <strong>Câu chuyện shop Etsy:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_story_info.etsy_shop_story || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Địa điểm:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_story_info.location || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Website:</strong> 
                                <div className="mt-1">
                                  {etsyInfoPack.trusted_story_info.website ? (
                                    <a href={etsyInfoPack.trusted_story_info.website} target="_blank" rel="noopener noreferrer">
                                      {etsyInfoPack.trusted_story_info.website}
                                    </a>
                                  ) : '-'}
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Facebook:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_story_info.facebook_username || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>Instagram:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_story_info.instagram_username || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>X (Twitter):</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_story_info.x_username || '-'}</div>
                              </Col>
                              <Col md="6">
                                <strong>YouTube:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_story_info.youtube_channel || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <strong>Là template:</strong> 
                                <div className="mt-1">
                                  <Badge 
                                    bg={etsyInfoPack.trusted_story_info.is_template ? 'info' : 'secondary'} 
                                    style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                  >
                                    {etsyInfoPack.trusted_story_info.is_template ? 'Có' : 'Không'}
                                  </Badge>
                                </div>
                              </Col>
                              <Col md="6">
                                <strong>Template MID:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_story_info.ref_template_mid || '-'}</div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="12">
                                <strong>Ghi chú:</strong> 
                                <div className="mt-1">{etsyInfoPack.trusted_story_info.note || '-'}</div>
                              </Col>
                            </Row>
                          </div>
                        ) : (
                          <div className="text-center text-muted">
                            <p>Không có thông tin Story</p>
                          </div>
                        )}
                      </div>
                    </Tab>
                  </Tabs>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Edit Modal */}
        <Modal show={showEditModal} onHide={this.handleCloseEditModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh sửa Etsy Info Pack</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Tabs defaultActiveKey="basic" className="mb-3">
                <Tab eventKey="basic" title="Thông tin cơ bản">
                  <Row className="mb-3">
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Trusted Person MID</Form.Label>
                        <Form.Control
                          type="text"
                          value={editFormData.trusted_person_mid}
                          onChange={(e) => this.handleFormChange('trusted_person_mid', e.target.value)}
                          placeholder="Nhập Trusted Person MID"
                        />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Valid C3D Number</Form.Label>
                        <Form.Control
                          type="text"
                          value={editFormData.valid_c3d_number}
                          onChange={(e) => this.handleFormChange('valid_c3d_number', e.target.value)}
                          placeholder="Nhập Valid C3D Number"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Scan Person MID</Form.Label>
                        <Form.Control
                          type="text"
                          value={editFormData.scan_person_mid}
                          onChange={(e) => this.handleFormChange('scan_person_mid', e.target.value)}
                          placeholder="Nhập Scan Person MID"
                        />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Device Pack Location ID</Form.Label>
                        <Form.Control
                          type="text"
                          value={editFormData.device_pack_location_id}
                          onChange={(e) => this.handleFormChange('device_pack_location_id', e.target.value)}
                          placeholder="Nhập Device Pack Location ID"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Trạng thái</Form.Label>
                        <Form.Select
                          value={editFormData.status}
                          onChange={(e) => this.handleFormChange('status', e.target.value)}
                        >
                          <option value="ACTIVE">Hoạt động</option>
                          <option value="INACTIVE">Không hoạt động</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                </Tab>

                <Tab eventKey="bank" title="Thông tin ngân hàng">
                  <Row className="mb-3">
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Trusted Bank Account MID</Form.Label>
                        <Form.Control
                          type="text"
                          value={editFormData.trusted_bank_acc_mid}
                          onChange={(e) => this.handleFormChange('trusted_bank_acc_mid', e.target.value)}
                          placeholder="Nhập Trusted Bank Account MID"
                        />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Trusted Bank Visa MID</Form.Label>
                        <Form.Control
                          type="text"
                          value={editFormData.trusted_bank_visa_mid}
                          onChange={(e) => this.handleFormChange('trusted_bank_visa_mid', e.target.value)}
                          placeholder="Nhập Trusted Bank Visa MID"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Tab>

                <Tab eventKey="email" title="Thông tin Email">
                  <Row className="mb-3">
                    <Col md="6">
                      <Form.Group className="mb-3">
                        <Form.Label>Email 1 MID</Form.Label>
                        <Form.Control
                          type="text"
                          value={editFormData.email1_mid}
                          onChange={(e) => this.handleFormChange('email1_mid', e.target.value)}
                          placeholder="Nhập Email 1 MID"
                        />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group className="mb-3">
                        <Form.Label>Email 2 MID</Form.Label>
                        <Form.Control
                          type="text"
                          value={editFormData.email2_mid}
                          onChange={(e) => this.handleFormChange('email2_mid', e.target.value)}
                          placeholder="Nhập Email 2 MID"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Tab>

                <Tab eventKey="story" title="Thông tin Story">
                  <Row className="mb-3">
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Trusted Story MID</Form.Label>
                        <Form.Control
                          type="text"
                          value={editFormData.trusted_story_mid}
                          onChange={(e) => this.handleFormChange('trusted_story_mid', e.target.value)}
                          placeholder="Nhập Trusted Story MID"
                        />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Địa chỉ người bán</Form.Label>
                        <Form.Control
                          type="text"
                          value={editFormData.seller_address}
                          onChange={(e) => this.handleFormChange('seller_address', e.target.value)}
                          placeholder="Nhập địa chỉ người bán"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Số SIM / Số điện thoại</Form.Label>
                        <Form.Control
                          type="text"
                          value={editFormData.sim_mid}
                          onChange={(e) => this.handleFormChange('sim_mid', e.target.value)}
                          placeholder="Nhập số SIM / số điện thoại"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>Ghi chú</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={editFormData.note}
                          onChange={(e) => this.handleFormChange('note', e.target.value)}
                          placeholder="Nhập ghi chú..."
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Tab>
              </Tabs>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSubmitEdit}>
              Lưu thay đổi
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Setup Etsy Info Modal */}
        <Modal show={this.state.showSetupEtsyInfoModal} onHide={this.handleCloseSetupEtsyInfoModal} size="lg">
          <Modal.Header closeButton className="bg-success text-white">
            <Modal.Title>
              <i className="fas fa-cog me-2"></i>
              Setup Etsy Info - {etsyInfoPack?.MID}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {etsyInfoPack && (
              <div>
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-success">Thông tin cần thiết cho Setup Shop Etsy</h5>
                    <hr />
                  </Col>
                </Row>

                {/* 1. Thông tin AnyDesk */}
                <div className="mb-4">
                  <h6 className="text-primary mb-3">🔑 Thông tin AnyDesk</h6>
                  
                  <Row className="mb-3">
                    <Col md="4">
                      <strong>AnyDesk ID:</strong>
                    </Col>
                    <Col md="8">
                      <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                        <span style={{ flex: 1 }}>
                          {etsyInfoPack.device_pack_info?.anydesk_id || '-'}
                        </span>
                        {etsyInfoPack.device_pack_info?.anydesk_id && (
                          <FaCopy 
                            size={14} 
                            className="text-muted"
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.copyToClipboard(etsyInfoPack.device_pack_info.anydesk_id)}
                            title="Copy AnyDesk ID"
                          />
                        )}
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="4">
                      <strong>AnyDesk Password:</strong>
                    </Col>
                    <Col md="8">
                      <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                        <span style={{ flex: 1 }}>
                          {etsyInfoPack.device_pack_info?.anydesk_password || '-'}
                        </span>
                        {etsyInfoPack.device_pack_info?.anydesk_password && (
                          <FaCopy 
                            size={14} 
                            className="text-muted"
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.copyToClipboard(etsyInfoPack.device_pack_info.anydesk_password)}
                            title="Copy AnyDesk Password"
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>

                <hr className="my-4" />

                {/* 2. Thông tin Setup Shop */}
                <div className="mb-4">
                  <h6 className="text-primary mb-3">📋 Thông tin Setup Shop</h6>

                {/* 1. Etsy Shop Name */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>Etsy Shop Name:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {etsyInfoPack.trusted_story_info?.etsy_shop_name || '-'}
                      </span>
                      {etsyInfoPack.trusted_story_info?.etsy_shop_name && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(etsyInfoPack.trusted_story_info.etsy_shop_name)}
                          title="Copy Etsy Shop Name"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* 2. First Name, Last Name */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>First Name, Last Name:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {etsyInfoPack.trusted_person_info?.full_name_english || '-'}
                      </span>
                      {etsyInfoPack.trusted_person_info?.full_name_english && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(etsyInfoPack.trusted_person_info.full_name_english)}
                          title="Copy Full Name"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* 3. Date of Birth */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>Date of Birth:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {etsyInfoPack.valid_c3d_person_info?.c3d_dob || '-'}
                      </span>
                      {etsyInfoPack.valid_c3d_person_info?.c3d_dob && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(etsyInfoPack.valid_c3d_person_info.c3d_dob)}
                          title="Copy Date of Birth"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* 4. Citizenship ID Number */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>Citizenship ID Number:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {etsyInfoPack.valid_c3d_number || '-'}
                      </span>
                      {etsyInfoPack.valid_c3d_number && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(etsyInfoPack.valid_c3d_number)}
                          title="Copy Citizenship ID"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* 5. Taxpayer Address */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>Taxpayer Address:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {etsyInfoPack.seller_address || '-'}
                      </span>
                      {etsyInfoPack.seller_address && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(etsyInfoPack.seller_address)}
                          title="Copy Taxpayer Address"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* 6. Phone Number */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>Phone Number:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {etsyInfoPack.sim_mid || '-'}
                      </span>
                      {etsyInfoPack.sim_mid && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(etsyInfoPack.sim_mid)}
                          title="Copy Phone Number"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* 7. Bank Information */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>Bank Name:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {etsyInfoPack.trusted_bank_account_info?.bank_short_name || '-'}
                      </span>
                      {etsyInfoPack.trusted_bank_account_info?.bank_short_name && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(etsyInfoPack.trusted_bank_account_info.bank_short_name)}
                          title="Copy Bank Name"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>Account Number:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {etsyInfoPack.trusted_bank_account_info?.account_number || '-'}
                      </span>
                      {etsyInfoPack.trusted_bank_account_info?.account_number && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(etsyInfoPack.trusted_bank_account_info.account_number)}
                          title="Copy Account Number"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>SWIFT BIC:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {this.getSwiftCodeFromBankBrand(etsyInfoPack.trusted_bank_account_info?.bank_short_name) || '-'}
                      </span>
                      {this.getSwiftCodeFromBankBrand(etsyInfoPack.trusted_bank_account_info?.bank_short_name) && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(this.getSwiftCodeFromBankBrand(etsyInfoPack.trusted_bank_account_info?.bank_short_name))}
                          title="Copy SWIFT BIC"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                </div>

                <Row className="mt-4">
                  <Col>
                    <div className="alert alert-info">
                      <i className="fas fa-info-circle me-2"></i>
                      <strong>Lưu ý:</strong> Thông tin này được tổng hợp từ các nguồn dữ liệu liên kết. 
                      Vui lòng kiểm tra và cập nhật nếu cần thiết trước khi sử dụng cho setup shop Etsy.
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseSetupEtsyInfoModal}>
              <i className="fas fa-times me-1"></i>
              Đóng
            </Button>
            <Button variant="success" onClick={() => {
              // Copy all info to clipboard
              const info = etsyInfoPack;
              const setupInfo = {
                anydeskId: info.device_pack_info?.anydesk_id || '',
                anydeskPassword: info.device_pack_info?.anydesk_password || '',
                shopName: info.trusted_story_info?.etsy_shop_name || '',
                fullName: info.trusted_person_info?.full_name_english || '',
                dateOfBirth: info.valid_c3d_person_info?.c3d_dob || '',
                citizenshipId: info.valid_c3d_number || '',
                taxpayerAddress: info.seller_address || '',
                bankName: info.trusted_bank_account_info?.bank_short_name || '',
                accountNumber: info.trusted_bank_account_info?.account_number || '',
                swiftCode: this.getSwiftCodeFromBankBrand(info.trusted_bank_account_info?.bank_short_name) || '',
                phoneNumber: info.sim_mid || ''
              };
              
              const text = `Etsy Shop Setup Info:
AnyDesk ID: ${setupInfo.anydeskId}
AnyDesk Password: ${setupInfo.anydeskPassword}
Shop Name: ${setupInfo.shopName}
Full Name: ${setupInfo.fullName}
Date of Birth: ${setupInfo.dateOfBirth}
Citizenship ID: ${setupInfo.citizenshipId}
Taxpayer Address: ${setupInfo.taxpayerAddress}
Phone Number: ${setupInfo.phoneNumber}
Bank Name: ${setupInfo.bankName}
Account Number: ${setupInfo.accountNumber}
SWIFT BIC: ${setupInfo.swiftCode}`;
              
              navigator.clipboard.writeText(text);
              this.showToast('Đã copy thông tin setup vào clipboard!', 'success');
            }}>
              <i className="fas fa-copy me-1"></i>
              Copy Info
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Photos Modal */}
        <Modal show={this.state.showPhotosModal} onHide={this.handleClosePhotosModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-images me-2"></i>
              Xem ảnh ({this.state.currentPhotoIndex + 1}/{this.state.selectedPhotos.length})
            </Modal.Title>
          </Modal.Header>
          {this.state.selectedPhotos.length > 1 && (
            <div className="text-center text-muted small mb-2" style={{ backgroundColor: '#f8f9fa', padding: '8px' }}>
              <i className="fas fa-keyboard me-1"></i>
              Sử dụng phím mũi tên ← → để chuyển ảnh, ESC để đóng
            </div>
          )}
          <Modal.Body>
            {this.state.selectedPhotos.length > 0 ? (
              <div className="text-center">
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <img 
                    src={this.state.selectedPhotos[this.state.currentPhotoIndex].link} 
                    alt={this.state.selectedPhotos[this.state.currentPhotoIndex].description || `Ảnh ${this.state.currentPhotoIndex + 1}`}
                    style={{
                      maxWidth: '100%',
                      maxHeight: '70vh',
                      objectFit: 'contain',
                      borderRadius: '8px',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                    }}
                  />
                  
                  {/* Navigation buttons */}
                  {this.state.selectedPhotos.length > 1 && (
                    <>
                      <Button
                        variant="light"
                        style={{
                          position: 'absolute',
                          left: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          borderRadius: '50%',
                          width: '50px',
                          height: '50px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '2px solid rgba(0,0,0,0.1)',
                          backgroundColor: 'rgba(255,255,255,0.9)',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                          zIndex: 10
                        }}
                        onClick={this.handlePrevPhoto}
                        title="Ảnh trước (←)"
                      >
                        <FaChevronLeft size={16} color="#333" />
                      </Button>
                      
                      <Button
                        variant="light"
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          borderRadius: '50%',
                          width: '50px',
                          height: '50px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '2px solid rgba(0,0,0,0.1)',
                          backgroundColor: 'rgba(255,255,255,0.9)',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                          zIndex: 10
                        }}
                        onClick={this.handleNextPhoto}
                        title="Ảnh tiếp theo (→)"
                      >
                        <FaChevronRight size={16} color="#333" />
                      </Button>
                    </>
                  )}
                </div>
                
                {/* Photo description */}
                {this.state.selectedPhotos[this.state.currentPhotoIndex].description && (
                  <div className="mt-3">
                    <p className="text-muted mb-0">
                      {this.state.selectedPhotos[this.state.currentPhotoIndex].description}
                    </p>
                  </div>
                )}
              </div>
            ) : (
              <div className="text-center text-muted">
                <p>Không có ảnh để hiển thị</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-between w-100">
              <div>
                {this.state.selectedPhotos.length > 0 && (
                  <small className="text-muted">
                    Ảnh {this.state.currentPhotoIndex + 1} / {this.state.selectedPhotos.length}
                  </small>
                )}
              </div>
              <div className="d-flex gap-2">
                {this.state.selectedPhotos.length > 0 && (
                  <>
                    <Button 
                      variant="outline-primary" 
                      size="sm"
                      onClick={() => this.handleDownloadImage(
                        this.state.selectedPhotos[this.state.currentPhotoIndex].link,
                        `scan_person_photo_${this.state.currentPhotoIndex + 1}.jpg`
                      )}
                    >
                      <FaDownload className="me-1" />
                      Tải xuống
                    </Button>
                    <Button 
                      variant="outline-secondary" 
                      size="sm"
                      onClick={() => window.open(this.state.selectedPhotos[this.state.currentPhotoIndex].link, '_blank')}
                    >
                      <FaExternalLinkAlt className="me-1" />
                      Mở tab mới
                    </Button>
                  </>
                )}
                <Button variant="secondary" onClick={this.handleClosePhotosModal}>
                  Đóng
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        {/* Toast */}
        <ToastContainer position="top-end" className="p-3">
          <Toast show={showToast} onClose={() => this.setState({ showToast: false })}>
            <Toast.Header>
              <strong className="me-auto">
                {toastType === 'success' ? 'Thành công' : 'Lỗi'}
              </strong>
            </Toast.Header>
            <Toast.Body>
              {toastMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    etsyInfoPack: state.tkt1EtsyInfoPackReducer.etsyInfoPack,
    bankBrands: state.tkt1BankBrandReducer.bankBrands
  };
};

export default connect(mapStateToProps, { 
  getTKT1EtsyInfoPackByMID, 
  updateTKT1EtsyInfoPack, 
  getTKT1BankBrands 
})(TKT1EtsyInfoPackDetail);
